import { storageService } from "@/_services";
export const storage = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    upload: {
      data: [],
      status: {},
    },
    delete: {
      data: {},
      status: {},
    },
    file: {
      data: {},
      status: {},
    },
    replace: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getFilesRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getFilesSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getFilesError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    uploadFileRequest(state) {
      state.upload.status = {
        uploading: true,
      };
    },
    uploadFileError(state, error) {
      state.upload.data = null;
      state.upload.status = {
        error,
      };
    },
    uploadFileSuccess(state, response) {
      state.upload.data = response;
      state.upload.status = {
        uploaded: true,
      };
    },
    replaceFileRequest(state) {
      state.replace.status = {
        replacing: true,
      };
    },
    replaceFileError(state, error) {
      state.replace.data = null;
      state.replace.status = {
        error,
      };
    },
    replaceFileSuccess(state, response) {
      state.replace.data = response;
      state.replace.status = {
        replaced: true,
      };
    },
    downloadFileRequest(state) {
      state.file.status = {
        downloading: true,
      };
    },
    downloadFileSuccess(state, response) {
      state.file.data = response;
      state.file.status = {
        downloaded: true,
      };
    },
    downloadFileError(state, error) {
      state.file.data = null;
      state.file.status = {
        error,
      };
    },
    deleteFileRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteFileSuccess(state, pdf) {
      state.delete.data = pdf;
      state.delete.status = {
        deleted: true,
      };
    },
    deleteFileError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
  },
  actions: {
    getFiles({ commit }, request) {
      commit("getFilesRequest");
      storageService
        .getFiles(request)
        .then((response) => {
          commit("getFilesSuccess", response);
        })
        .catch((error) => {
          commit("getFilesError", error);
        });
    },
    uploadFile({ commit }, request) {
      commit("uploadFileRequest");
      storageService
        .uploadFile(request)
        .then((res) => {
          commit("uploadFileSuccess", res);
        })
        .catch((error) => {
          commit("uploadFileError", error);
        });
    },
    replaceFile({ commit }, request) {
      commit("replaceFileRequest");
      storageService
        .replaceFile(request.container, request.path, request.body)
        .then((res) => {
          commit("replaceFileSuccess", res);
        })
        .catch((error) => {
          commit("replaceFileError", error);
        });
    },
    downloadFile({ commit }, req) {
      commit("downloadFileRequest");
      storageService
        .downloadFile(req.container, req.path)
        .then((res) => {
          commit("downloadFileSuccess", res);
        })
        .catch((error) => {
          commit("downloadFileError", error);
        });
    },
    deleteFile({ commit }, req) {
      commit("deleteFileRequest");
      storageService
        .deleteFile(req.container, req.path)
        .then((deleteFile) => {
          commit("deleteFileSuccess", deleteFile);
        })
        .catch((error) => {
          commit("deleteFileError", error);
        });
    },
  },
};
